import styled from 'styled-components';

export const BlockWrapper = styled.div`
	padding: 40px 40px 0;

	@media ${props => props.theme.device.tablet} {
		padding: 40px 20px 0;
	}

	@media ${props => props.theme.device.smTablet} {
		padding: 32px 20px 0;
	}

	@media ${props => props.theme.device.mobile} {
		padding: 32px 12px 0;
	}
`;
